export const chassisRoutes = {
  path: 'chassis',
  handle: {
    appUniKey: 'dvm_chassis',
  },
  lazy: () => import('./chassis/ChassisGroup'),
};
